// Hasta Detay › Kişisel Bilgiler — "WhatsApp onayı" satırı (spec 2026-10-06).
// Onayı YALNIZ hasta verir (uygulamadaki anahtar ya da WhatsApp'ta DUR/BAŞLA); klinik
// yalnız görür, değiştiremez (2026-10-08 — klinik beyanı kaldırıldı).
// Kliniğin whatsapp modülü kapalıysa ya da klinik bağlamı yoksa (admin görünümü) satır çizilmez.

import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import InfoRow from "../../atoms/InfoRow";
import useAuth from "../../../hooks/useAuth";
import { useClinicModule } from "../../../hooks/useClinicModule";
import { COLORS, TYPO } from "../../../styles/uiConstants";
import { optInReasonText } from "../../../constants/whatsapp";
import useTerms from "../../../hooks/useTerms";
import { useWhatsAppOptInQuery } from "../../../store/whatsappApi";

export default function WhatsAppConsentRow({ patientId, token, noBorder = false }) {
  const { auth } = useAuth();
  const terms = useTerms();
  const moduleOn = useClinicModule("whatsapp");
  const inClinic = Boolean(auth?.clinic);
  const visible = moduleOn && inClinic && Boolean(patientId);

  const { data, isLoading } = useWhatsAppOptInQuery({ token, patientId }, { skip: !visible || !token });

  if (!visible) return null;
  const view = data?.data || null;
  const effective = Boolean(view?.effective);

  return (
    <InfoRow label="WhatsApp onayı" noBorder={noBorder}>
      {isLoading && !view ? (
        <Skeleton variant="text" width="60%" height={24} />
      ) : (
        <Box sx={{ minHeight: 28, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Typography sx={{ fontSize: TYPO.body, color: effective ? COLORS.successDarker : COLORS.slate700 }}>
            {effective ? "Var" : "Yok"}
            <Box component="span" sx={{ color: COLORS.slate500 }}>
              {" · "}
              {optInReasonText(view)}
            </Box>
          </Typography>
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate400 }}>
            {view && view.hasPhone === false
              ? "Kayıtlı telefon yok; WhatsApp mesajı gönderilemez."
              : `Onayı yalnız ${terms.patient.toLocaleLowerCase("tr-TR")} verir: uygulamadaki anahtar ya da WhatsApp'ta DUR/BAŞLA.`}
          </Typography>
        </Box>
      )}
    </InfoRow>
  );
}
